module.exports = __webpack_public_path__ + "media/images/gallery/constellations/aries/ari_vis-c53f4ffde303ce73f5839c63088c2024.jpg";